import Breadcrumb from "../components/Breadcrumb";
import UserPermissions from "../components/UserPermissions";

const UserPermissionsPage = () => {
  return (
    <>
      {/* Breadcrumb */}
      <Breadcrumb title="User Permissions" />

      <UserPermissions />
    </>
  );
};

export default UserPermissionsPage;
